// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: mujoL4gD3qd1ezKDLZ31rZ
// Component: IQmvc6tT46
import * as React from "react"
import { Link } from "gatsby"
import * as p from "@plasmicapp/react-web"
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  useTrigger,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web"
import { useMode } from "./PlasmicGlobalVariant__Mode" // plasmic-import: zulsK3o-3W/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_jeffdo_es.module.css" // plasmic-import: mujoL4gD3qd1ezKDLZ31rZ/projectcss
import * as sty from "./PlasmicWorkCard.module.css" // plasmic-import: IQmvc6tT46/css
import orgDesignMeo1PxVz7 from "./images/orgDesign.png" // plasmic-import: meo1PxVZ7/picture

export const PlasmicWorkCard__VariantProps = new Array()

export const PlasmicWorkCard__ArgProps = new Array(
  "image",
  "title",
  "hoverText",
  "href"
)

function PlasmicWorkCard__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props
  const [isCardHover, triggerCardHoverProps] = useTrigger("useHover", {})
  const triggers = {
    hover_card: isCardHover,
  }

  const globalVariants = ensureGlobalVariants({
    mode: useMode(),
  })

  return (
    <p.PlasmicLink
      data-plasmic-name={"card"}
      data-plasmic-override={overrides.card}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.card,
        "work-card",
        {
          [projectcss.global_mode_dark]: hasVariant(
            globalVariants,
            "mode",
            "dark"
          ),

          [projectcss.global_mode_reveal]: hasVariant(
            globalVariants,
            "mode",
            "reveal"
          ),

          [sty.cardglobal_mode_dark]: hasVariant(
            globalVariants,
            "mode",
            "dark"
          ),

          [sty.cardglobal_mode_dark_global_mode_reveal]:
            hasVariant(globalVariants, "mode", "dark") &&
            hasVariant(globalVariants, "mode", "reveal"),
          [sty.cardglobal_mode_reveal]: hasVariant(
            globalVariants,
            "mode",
            "reveal"
          ),
        }
      )}
      component={Link}
      href={args.href}
      platform={"gatsby"}
      tabIndex={0}
      data-plasmic-trigger-props={[triggerCardHoverProps]}
    >
      {(hasVariant(globalVariants, "mode", "reveal") ? false : true)
        ? p.renderPlasmicSlot({
            defaultContents: (
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__lEXel)}
                displayHeight={"100%"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"100%"}
                loading={"lazy"}
                src={{
                  src: orgDesignMeo1PxVz7,
                  fullWidth: 2880,
                  fullHeight: 2048,
                  aspectRatio: undefined,
                }}
              />
            ),

            value: args.image,
          })
        : null}

      <div
        className={classNames(projectcss.all, sty.freeBox__nzVMu, {
          [sty.freeBoxglobal_mode_reveal__nzVMuv94Jk]: hasVariant(
            globalVariants,
            "mode",
            "reveal"
          ),
        })}
      >
        <div className={classNames(projectcss.all, sty.freeBox__haSw)}>
          {p.renderPlasmicSlot({
            defaultContents: "an org design tool",
            value: args.title,
            className: classNames(sty.slotTargetTitle, {
              [sty.slotTargetTitleglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            }),
          })}
        </div>
      </div>

      {(triggers.hover_card ? true : true) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__uLcd4, {
            [sty.freeBoxglobal_mode_dark_global_mode_reveal__uLcd4JYvhV94Jk]:
              hasVariant(globalVariants, "mode", "dark") &&
              hasVariant(globalVariants, "mode", "reveal"),
            [sty.freeBoxglobal_mode_reveal__uLcd4V94Jk]: hasVariant(
              globalVariants,
              "mode",
              "reveal"
            ),
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: "coming soon",
            value: args.hoverText,
            className: classNames(sty.slotTargetHoverText, {
              [sty.slotTargetHoverTextglobal_mode_dark_global_mode_reveal]:
                hasVariant(globalVariants, "mode", "dark") &&
                hasVariant(globalVariants, "mode", "reveal"),
            }),
          })}
        </div>
      ) : null}
    </p.PlasmicLink>
  )
}

const PlasmicDescendants = {
  card: ["card"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicWorkCard__ArgProps,
      internalVariantPropNames: PlasmicWorkCard__VariantProps,
    })

    return PlasmicWorkCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "card") {
    func.displayName = "PlasmicWorkCard"
  } else {
    func.displayName = `PlasmicWorkCard.${nodeName}`
  }
  return func
}

export const PlasmicWorkCard = Object.assign(
  // Top-level PlasmicWorkCard renders the root element
  makeNodeComponent("card"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicWorkCard
    internalVariantProps: PlasmicWorkCard__VariantProps,
    internalArgProps: PlasmicWorkCard__ArgProps,
  }
)

export default PlasmicWorkCard
/* prettier-ignore-end */
